module.exports = __webpack_public_path__ + "img/40_69_003_270.7d233a89.jpg";